export default "   \n    <a href=\"http://sms365trans.jdaas.com\" target=\"_blank\" >Check SMS Balance</a>\n"